import { CategorySub, Maybe } from '@karakuri-web/faq-type'

let dictionary: Record<string, CategorySub>
export async function loadDictionary() {
  if (!dictionary) {
    const categories = await fetch('/categories.json').then<Maybe<CategorySub[]>>(response =>
      response.json()
    )
    dictionary = (categories || []).reduce<Record<string, CategorySub>>((acc, p) => {
      if (!p || !p.id) {
        return acc
      }
      return { ...acc, [p.id]: p }
    }, {})
  }
  return dictionary
}
